import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeliveryShareState, mainDeliveryShareKey } from './modal-delivery-share.reducer';

export const selectDeliveryShare = createFeatureSelector<DeliveryShareState>(mainDeliveryShareKey);

export const getSharedForm = createSelector(
  selectDeliveryShare,
  (state: DeliveryShareState) => state && state.share,
);

export const getSharedReasons = createSelector(
  selectDeliveryShare,
  (state: DeliveryShareState) => state && state.reasons,
);
